var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SessionStorage, } from '@lean-body/src/infra';
import { SnsProvider, } from '@lean-body/src/interfaces';
import bind from 'bind-decorator';
import { getUserAgent, randomString } from '../util';
import Cookies from 'universal-cookie';
// 各種行動イベントのトラッキングを担う。
export class Tracker {
    constructor(storage, fbPixelClient, cloudFunctionClient, gaClient, lambdaFunctionClient, oaiqClient, config) {
        Object.defineProperty(this, "fbPixelClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cloudFunctionClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tagClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gaClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "storage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lambdaFunctionClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "oaiqClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "session", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "sessionStorage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "playHistory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "recommendClickedLesson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        this.storage = storage;
        this.fbPixelClient = fbPixelClient;
        this.gaClient = gaClient;
        this.cloudFunctionClient = cloudFunctionClient;
        this.lambdaFunctionClient = lambdaFunctionClient;
        this.oaiqClient = oaiqClient;
        this.config = config;
        this.sessionStorage = new SessionStorage();
        this.setSession();
        this.setReferrer();
        this.setInitialReferrer();
    }
    setUserID(userID) {
        this.userId = userID;
    }
    setTagClient(tagClient) {
        this.tagClient = tagClient;
    }
    setReferrer() {
        this.cloudFunctionClient.setReferrer();
    }
    setInitialReferrer() {
        const lpMessageReferre = this.storage.loadLpMessageReferrer;
        if (lpMessageReferre) {
            this.cloudFunctionClient.setInitialReferrer(lpMessageReferre);
        }
    }
    trackView() {
        this.cloudFunctionClient.trackView(this.userId, this.session);
        this.tagClient.trackView();
    }
    trackClickEvent(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.tagClient.trackClick(params.category, params.label, params.value);
        });
    }
    trackSlideEvent(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.tagClient.trackSlide(params.category, params.label, params.value);
        });
    }
    trackSignUp(userId, email) {
        this.cloudFunctionClient.trackSignUp(userId, email);
    }
    trackSignIn(userId, email, authMethod) {
        this.cloudFunctionClient.trackSignIn(userId, email, authMethod);
    }
    trackCCRegistered(userId, usrPayment, campaignCode, reloclubKid) {
        const params = {
            cardLastFour: usrPayment.cardLastFour,
            subPlanId: usrPayment.subPlanId,
            curPeriodEndTime: usrPayment.curPeriodEndTime,
            trialEndTime: usrPayment.trialEndTime || 0,
            campaignCode: campaignCode || '',
            reloclubKid: reloclubKid || '',
        };
        this.cloudFunctionClient.ccRegister(userId, params);
        this.gaClient.trackConversionGTM(userId, campaignCode);
        this.oaiqClient.measureOrderCreated(usrPayment.currentPlan.amount, `${userId}-${usrPayment.subPlanId}`);
    }
    trackDiagnosisStart() {
        this.gaClient.trackDiagnosisStart();
    }
    trackDiagnosisComplete() {
        this.gaClient.trackDiagnosisComplete();
    }
    trackDiagnosisPlanGenerated() {
        this.gaClient.trackDiagnosisPlanGenerated();
    }
    trackDiagnosisCCView() {
        this.gaClient.trackDiagnosisCCView();
    }
    trackPixelEvent(eventName) {
        if (!this.config.isProdOrStg)
            return;
        const cookies = new Cookies();
        const eventID = randomString(10);
        const params = {
            eventID: eventID,
            eventName: eventName,
            clickID: cookies.get('_fbc'),
            browserID: cookies.get('_fbp'),
            clientUserAgent: getUserAgent(),
            actionSource: 'website',
            eventSourceUrl: document.URL,
        };
        this.fbPixelClient.trackEvent(eventName, eventID);
        this.lambdaFunctionClient.postConversionToFB(params);
    }
    trackBecomeDormant() {
        this.cloudFunctionClient.trackBecomeDormant();
    }
    trackStartLesson(lesson, lessonParent) {
        this.playHistory.push(lesson);
        const params = this.compileLessonMovieEventParams(lesson, 0, lessonParent);
        this.cloudFunctionClient.trackVideoPlay(this.userId, params);
    }
    trackSuspendLesson(userId, lesson, time, lessonParent) {
        const params = this.compileLessonMovieEventParams(lesson, 0, lessonParent);
        this.cloudFunctionClient.trackVideoStop(userId, params, time);
    }
    trackQuitLesson(lesson, time, stats, userId, lessonParent, isAutoPlay) {
        const params = this.compileLessonMovieEventParams(lesson, time, lessonParent, stats, false);
        this.cloudFunctionClient.trackVideoPlayStats(userId, isAutoPlay, params);
    }
    trackCompleteLesson(lesson, stats, userId, lessonParent, isAutoPlay) {
        const params = this.compileLessonMovieEventParams(lesson, stats.duration, lessonParent, stats, true);
        this.cloudFunctionClient.trackVideoPlayStats(userId, isAutoPlay, params);
    }
    trackStartLiveLesson(userId, liveLessonId, playerUrl) {
        const params = {
            liveLessonId: liveLessonId,
            movieId: playerUrl,
            playSec: 0,
        };
        this.cloudFunctionClient.trackVideoPlay(userId, params);
    }
    trackQuitLiveLesson(userId, liveLessonId, playerUrl, session) {
        const params = {
            liveLessonId: liveLessonId,
            movieId: playerUrl,
            playSec: session.dedupedplayDuration,
            isFullPlay: session.completed,
            playDuration: session.playDuration,
            dedupedPlayDuration: session.dedupedplayDuration,
            playDurationRatio: session.playDurationRatio,
        };
        this.cloudFunctionClient.trackVideoPlayStats(userId, false, params);
    }
    trackFavoriteLesson(lesson, status) {
        this.cloudFunctionClient.trackFavoriteLesson(lesson.id, status);
    }
    trackFavoriteProgram(programId, status) {
        this.cloudFunctionClient.trackFavoriteProgram(programId, status);
    }
    trackClickSearchPartCard(tagId) {
        this.cloudFunctionClient.trackClickSearchPartCard(tagId);
    }
    trackClickSearchStyleCard(styleID) {
        this.cloudFunctionClient.trackClickSearchStyleCard(styleID);
    }
    trackSubmitSearch(word) {
        this.cloudFunctionClient.trackSubmitSearch(word);
    }
    trackClickSearchResultProgram(programID) {
        this.cloudFunctionClient.trackClickSearchResultProgram(programID);
    }
    trackClickSearchResultLesson(lessonID) {
        this.cloudFunctionClient.trackClickSearchResultLesson(lessonID);
    }
    trackReceivedBadge(badgeID, badgeName, badgeType) {
        this.cloudFunctionClient.trackReceivedBadge(badgeID, badgeName, badgeType);
    }
    trackClickMatchingAssessmentStart() {
        this.cloudFunctionClient.trackClickMatchingAssessmentStart();
    }
    trackClickChallengeStart(programId, start, end) {
        this.cloudFunctionClient.trackClickChallengeStart(programId, start, end);
    }
    trackClickUpdateChallengeStatus(programId, status, start, end) {
        this.cloudFunctionClient.trackClickUpdateChallengeStatus(programId, status, start, end);
    }
    trackClickPlanChange(plan, me) {
        this.cloudFunctionClient.trackClickPlanChange(plan, me);
    }
    // NOTE: 現在適用中のプランをQueuedPlanとして登録し、プラン変更が取り消された履歴を表現する.
    trackClickRemovePlan(me) {
        this.cloudFunctionClient.trackClickRemovePlan(me);
    }
    trackHomeBannerClick(banner) {
        this.cloudFunctionClient.trackHomeBannerClick(banner);
    }
    trackPlayLiveVideo(liveUrl, liveTitle, startPositionTime) {
        this.cloudFunctionClient.trackPlayLiveVideo(liveUrl, liveTitle, startPositionTime);
    }
    trackOriginalPlaylistBannerClick(pageName) {
        this.cloudFunctionClient.trackOriginalPlaylistBannerClick(pageName);
    }
    trackOriginalPlaylistCreate() {
        this.cloudFunctionClient.trackOriginalPlaylistCreate();
    }
    trackFirstViewCarouselClick(linkPath) {
        this.cloudFunctionClient.trackFirstViewCarouselClick(linkPath);
    }
    trackFirstViewBannerClick(linkPath) {
        this.cloudFunctionClient.trackFirstViewBannerClick(linkPath);
    }
    trackHomeClick(name) {
        this.cloudFunctionClient.trackHomeClick(name);
    }
    trackInvitaionLinkCopy() {
        return this.cloudFunctionClient.trackInvitaionLinkCopy();
    }
    trackTwitterDialogOpen(snsParams) {
        snsParams = Object.assign(Object.assign({}, snsParams), { snsProvider: SnsProvider.Twitter, userAction: 'dialog-open' });
        return this.cloudFunctionClient.trackSnsShareClick(snsParams);
    }
    trackTwitterShareClick(snsParams, isAuthorized) {
        snsParams = Object.assign(Object.assign({}, snsParams), { snsProvider: SnsProvider.Twitter, userAction: 'click-share', isAuthorized: isAuthorized });
        return this.cloudFunctionClient.trackSnsShareClick(snsParams);
    }
    trackTwitterPostTweetClick(snsParams) {
        snsParams = Object.assign(Object.assign({}, snsParams), { snsProvider: SnsProvider.Twitter, userAction: 'post-tweet', isAuthorized: true });
        return this.cloudFunctionClient.trackSnsShareClick(snsParams);
    }
    trackMypageProfileUpdate(profile) {
        return this.cloudFunctionClient.trackMypageProfileUpdate(profile);
    }
    trackCancelUnsubscribeBannerClick() {
        this.cloudFunctionClient.trackCancelUnsubscribeBannerClick();
    }
    trackClickMerchandise(merchandiseId) {
        this.cloudFunctionClient.trackClickMerchandise(merchandiseId);
    }
    trackUnsubscribeChatbot(chatbotSessionId, sectionId, descriptionId, choiceId, inputData, nextSectionId, isStart, isUnsubscribeButtonClick) {
        this.cloudFunctionClient.trackUnsubscribeChatbotLogs(chatbotSessionId, sectionId, descriptionId, choiceId, inputData, nextSectionId, isStart, isUnsubscribeButtonClick);
    }
    compileLessonMovieEventParams(lesson, time, lessonParent, videoStats, isFullPlay) {
        const params = Object.assign({ lessonId: lesson.id, movieId: lesson.videoId, playSec: time }, videoStats);
        if (lessonParent) {
            const playlist = lessonParent;
            if (playlist.isOriginalPlaylist) {
                params.originalPlaylistId = playlist.id;
            }
            else {
                params.programId = playlist.id;
            }
        }
        if (isFullPlay !== undefined) {
            params.isFullPlay = isFullPlay;
        }
        return params;
    }
    setSession() {
        let sid = this.sessionStorage.loadSession();
        if (!sid) {
            sid = this.sessionStorage.setupSession();
        }
        this.session = sid.session_id;
    }
}
__decorate([
    bind
], Tracker.prototype, "trackOriginalPlaylistBannerClick", null);
__decorate([
    bind
], Tracker.prototype, "trackOriginalPlaylistCreate", null);
__decorate([
    bind
], Tracker.prototype, "trackFirstViewCarouselClick", null);
__decorate([
    bind
], Tracker.prototype, "trackFirstViewBannerClick", null);
__decorate([
    bind
], Tracker.prototype, "trackHomeClick", null);
__decorate([
    bind
], Tracker.prototype, "trackInvitaionLinkCopy", null);
__decorate([
    bind
], Tracker.prototype, "trackTwitterDialogOpen", null);
__decorate([
    bind
], Tracker.prototype, "trackTwitterShareClick", null);
__decorate([
    bind
], Tracker.prototype, "trackTwitterPostTweetClick", null);
__decorate([
    bind
], Tracker.prototype, "trackMypageProfileUpdate", null);
